import { Button } from "antd";
import React, { useCallback } from "react";
import { DOWNLOAD_CMR_IN_DECLARANTS_TABLE } from "../../../../constants/events";
import ee from "../../../../services/EventEmitter";
import { Cmr } from "../../../../models/Cmr";
import Authorize from "../../../Authorize";
import { CAN_DOWNLOAD_CMR } from "../../../../constants/authorize";

interface Props {
  cmr: Cmr;
}

interface DeniedComponentProps {
  value: string;
}

const DeniedComponent: React.FC<DeniedComponentProps> = ({ value }) => {
  return <>{value}</>;
};

const DownloadCmr: React.FC<Props> = ({ cmr }) => {
  const onClickHandler = useCallback(() => {
    ee.emit(DOWNLOAD_CMR_IN_DECLARANTS_TABLE, {
      id: cmr.id,
    });
  }, [cmr]);

  return (
    <Authorize
      permission={CAN_DOWNLOAD_CMR}
      deniedComponent={<DeniedComponent value={cmr.cmr_number} />}
    >
      <Button type="primary" onClick={onClickHandler}>
        {cmr.cmr_number}
      </Button>
    </Authorize>
  );
};

export default DownloadCmr;
